module.exports = __webpack_public_path__ + "static/1-c3ebddf4142f52d779dfcf3fa41a49aa.jpg";